import { StatusItem } from "../../views/multiEshop/components/status";

export function getStatusSteps(): StatusItem[] {
  return [
    {
      number: 1,
      label: "selection",
    },
    {
      number: 2,
      label: "recap",
    },
    {
      number: 3,
      label: "contact",
    },
    {
      number: 4,
      label: "payment",
    },
  ];
}
